<template>
    <vue-easy-light-box
            loop
            :visible="lightBoxVisible"
            :imgs="lightBoxImages"
            :index="lightBoxIndex"
            @hide="hideLightBox">
    </vue-easy-light-box>
</template>

<script>
    import VueEasyLightBox from 'vue-easy-lightbox'
    export default {
        name: 'ImageLightBox',
        components: {VueEasyLightBox},
        data(){
            return {
                lightBoxVisible: false,
                lightBoxIndex: 0,
                lightBoxImages: [],
            };
        },
        methods:{
            showLightBox(media) {
                this.lightBoxImages = [];
                let that = this;
                media.forEach( function(item) {
                    that.lightBoxImages.push(item.url)
                })
                this.lightBoxVisible = true
            },
            hideLightBox() {
                this.lightBoxVisible = false
            },
        },
    };
</script>

<style scoped>
    .vel-modal {
        background: rgba(0, 0, 0, 0.8) !important;
    }
</style>